import React from 'react';
import { useWebBundleStaleness } from '../hooks/useWebBundleStaleness';

const GOLD = '#C9A84C';

export default function WebBundleUpdateBanner() {
  const { stale, refresh } = useWebBundleStaleness();

  if (!stale) return null;

  return (
    <button
      type="button"
      onClick={refresh}
      style={{
        width: '100%',
        background: `linear-gradient(135deg, ${GOLD}14, ${GOLD}08)`,
        border: 'none',
        borderBottom: `1px solid ${GOLD}35`,
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        position: 'relative',
        zIndex: 59,
        cursor: 'pointer',
        fontSize: 13,
        color: 'var(--text-primary)',
        lineHeight: 1.4,
        textAlign: 'center',
      }}
      aria-label="Refresh to load the latest Maestro update"
    >
      <span style={{ fontWeight: 600 }}>An update is ready — click to refresh</span>
    </button>
  );
}
